import Highway from '@dogstudio/highway'
import TweenMax from 'gsap/TweenMax'
import Loader from '../util/Loader'

export default class Fade extends Highway.Transition {
  in({ from, to, done }) {
    if (!this.elmLoader) this.elmLoader = document.querySelector('.loader')
    if (!this.elmHeader) this.elmHeader = document.querySelector('.header')
    if (!this.elmFooter) this.elmFooter = document.querySelector('.footer')

    window.scrollTo(0, 0)

    from.remove()

    TweenMax.set([to, this.elmFooter], { alpha: 0 })

    Loader.load(to)
      .then(() => {
        if (this.elmLoader) this.elmLoader.classList.remove('show')

        TweenMax.to([to, this.elmFooter], 0.75, {
          alpha: 1,
          onComplete: done
        })
      })
  }

  out({ from, done }) {
    if (!this.elmLoader) this.elmLoader = document.querySelector('.loader')
    if (!this.elmHeader) this.elmHeader = document.querySelector('.header')
    if (!this.elmFooter) this.elmFooter = document.querySelector('.footer')

    TweenMax.to([from, this.elmFooter], 0.75, {
      alpha: 0,
      onComplete: () => {
        if (this.elmLoader) this.elmLoader.classList.add('show')

        done()
      }
    })
  }
}



// WEBPACK FOOTER //
// ./scripts/transitions/Fade.js